<template>
  <div class="volet-wrapper" :class="{ show: showVolet }">
    <div class="button-toggle-wrapper">
      <transition name="fade">
        <messageNotif v-show="isShowMessage" :width="100" class="message-position"/>
      </transition>
      <ul>
        <li
          :class="{ active: this.section === 'commentaire' }"
          @click="handleClickShowVolet('commentaire')"
        >
          <div>
            <span class="notification-number">{{ notificationsCount }}</span>
            <font-awesome-icon :icon="['far', 'comment-alt']" />
          </div>
        </li>
        <li
          v-if="!modeVue"
          :class="{ active: this.section === 'acces' }"
          @click="handleClickShowVolet('acces', $event)"
        >
          <div>
            <font-awesome-icon :icon="['fas', 'users-cog']" />
          </div>
        </li>
        <li
          v-if="!modeVue"
          :class="{ active: this.section === 'styles' }"
          @click="handleClickShowVolet('styles', $event)">
          <div>
            <font-awesome-icon :icon="['fas', 'paint-brush']" />
          </div>
        </li>
      </ul>
    </div>
    <div class="toggle-volet-wrapper">

      <div class="volet-content-wrapper">
        <!-- composant commentaire -->
        <div
          class="composant-commentaire"
          v-show="this.section === 'commentaire'"
        >
          <div class="section-titre">
            <div
              :class="{ active: comActive }"
              @click="handleClickTitre('com')"
            >
              Commentaires
            </div>
            <div
              v-if="!modeVue"
              :class="{ active: notifActive }"
              @click="handleClickTitre('notif')"
            >
              Notifications
            </div>
          </div>
          <div class="section-contenu">
            <div class="contenu-commentaire" v-show="comActive">
              <!--comments-- v-if="this.isLoadedEntityId"></!--comments-->
              <comments
                v-if="this.isLoadedEntityId"
                :mode-vue="modeVue"
              ></comments>
            </div>
            <div
              v-if="!modeVue"
              class="contenu-notification"
              v-show="notifActive"
            >
              <notifications></notifications>
            </div>
          </div>
        </div>
        <!-- .composant commentaire -->
        <!-- .composant acces -->
        <div class="composant-acces" v-show="this.section === 'acces'">
          <!--div class="notification-box">
            <b-alert
              v-model="showDismissibleAlert"
              :variant="notifClass"
              dismissible
              fade
            >
              {{ message }}
            </b-alert>
          </!--div -->
          <acces-en-vue
            v-if="!modeVue"
            :entity-id="entityId"
            :type-module="typeModule"
            @onClickSend="handleClickSendAccessRequest"
            :users-token-list="usersTokenList"
            :list-module-in-modal="listModules"
            @onDeleteConfirm="handleDeleteInvitation"
            @onUpdated="onUpdated"
            :btn-disable="btnDisable"
            :not-loaded-list="notLoadedList"
          ></acces-en-vue>
        </div>
        <div class="composant-acces" v-show="this.section === 'styles'">
          <div class="my-padding">
              <a v-b-toggle.collapse-color role="button" class="style-btn collapsed">Couleurs enregistrées</a>
              <b-collapse id="collapse-color" class="mt-2">
                <div class="available-colors">
                  <span
                          v-for="(items, index) in availableColors"
                          :key="index"
                          :class="{'border': items.border, 'border-dark': items.borderDark}"
                          @click="toggleColorPickerVisibility(index, items.id, items.color)"
                          :style="{background: items.color}"
                          :color="items.color"
                  >
                  </span>
                  <color-picker
                          theme="light"
                          v-on-clickaway="away"
                          v-if="showFontColorPicker && canSetColors"
                          :sucker-hide="true"
                          :color="availableColors[colorIndex].color"
                          @changeColor="changeColor"
                  />
                </div>
              </b-collapse>
              <a href="#" class="style-btn">Styles</a>
          </div>
        </div>
        <!-- .composant acces -->
      </div>
    </div>
  </div>
</template>

<script>
import comments from './commentsComponents'
import notifications from './notifComponents'
import accesEnVue from './accesEnVue'
import { mapGetters, mapActions } from 'vuex'
import messageNotif from '../messageComponent'
import _ from 'lodash'
import colorPicker from '@caohenghu/vue-colorpicker'
import { directive as onClickaway } from 'vue-clickaway'
import axios from 'axios'
import { ENTRYPOINT } from '../../config/entrypoint'

export default {
  props: {
    modeVue: {
      type: Boolean,
      default: false
    }
  },
  components: {
    comments,
    notifications,
    accesEnVue,
    messageNotif,
    colorPicker
  },
  directives: {
    onClickaway: onClickaway
  },
  data () {
    return {
      colorIndex: 0,
      canSetColors: false,
      colorId: null,
      color: '#000000',
      availableColors: [],
      suckerCanvas: null,
      suckerArea: [],
      isSucking: false,
      showFontColorPicker: false,
      showVolet: false,
      isActive: false,
      comActive: true,
      notifActive: false,
      section: null,
      usersTokenList: [],
      listModules: {},
      voletIdProject: null,
      showDismissibleAlert: false,
      btnDisable: false,
      notLoadedList: false,
      notifClass: 'info',
      message: '',
      fichesEspace: []
    }
  },
  watch: {
    isFromNotif (newValue) {
      if (newValue) {
        this.comActive = !this.comActive
        this.notifActive = !this.notifActive
        setTimeout(() => { document.getElementById('comment-' + this.notifLink().commentaire.id).scrollIntoView() }, 500)
        this.setIsFromNotif(false)
      }
    },
    async $route (to, from) {
      if (to.params.idProject) {
        this.voletIdProject = parseInt(to.params.idProject)
      }
      if (to.name === 'specification_technique' || to.name === 'cahier_environnemental') {
        const payload = {
          type: this.$route.name,
          entite: parseInt(to.params.idProject),
          projectId: this.voletIdProject
        }
        const list = !this.modeVue ? await this.getListAccess(payload) : null
        this.usersTokenList = list ? list.data.data : list
      }
    },
    async entityId (newValue, oldValue) {
      const payload = {
        type: this.$route.name,
        entite: newValue,
        projectId: this.voletIdProject
      }
      const list = !this.modeVue ? await this.getListAccess(payload) : null
      this.usersTokenList = list ? list.data.data : list
    },
    voletIdProject (val) {
      if (!this.modeVue) {
        this.createListModuleInModal(val)
      }
    },
    ficheTableauData: {
      handler (val) {
        if (val && !this.modeVue) {
          this.fichesEspace = [...val.map(onglet => {
            const denomIndex = this.getDenominationIndex(onglet.columns)
            if (onglet.rows) {
              return onglet.rows.map((row, index) => {
                if (row != null && row.fiche != null) {
                  return {
                    id: row.fiche,
                    name: onglet.data[index][denomIndex],
                    tableau: onglet.nom
                  }
                }
              })
            }
          })].flat().filter(espace => espace != null)

          this.fichesEspace = _.mapValues(_.groupBy(this.fichesEspace, 'tableau'),
            ficheList => ficheList.map(fiche => _.omit(fiche, 'tableau')))

          // this.listModules['fiche_espace'] = this.fichesEspace
        } else {
          this.fichesEspace = []
        }
      },
      deep: true
    }
  },
  async created () {
    if (!this.voletIdProject) {
      this.voletIdProject = parseInt(this.$route.params.idProject)
    }

    const resp = await axios({ url: ENTRYPOINT + '/api/get-colors', method: 'GET' })

    this.$store.commit('SET_COLORS', resp.data.colors.map(({ color }) => color))

    this.availableColors = resp.data.colors
    this.canSetColors = resp.data.canSetColors
  },
  computed: mapGetters(['isShowMessage', 'notificationsCount', 'isFromNotif', 'isLoadedEntityId', 'entityId', 'typeModule', 'ficheTableauData']),
  methods: {
    ...mapGetters(['notifLink', 'listOnglet', 'listSchema', 'currentProject', 'setFiches', 'isProjectTemplate']),
    ...mapActions(['setMessage', 'setIsFromNotif', 'setAccess', 'getListAccess', 'listAllSchema', 'setTypeModule', 'deleteInvitation', 'getListOnglet']),
    async onUpdated () {
      const reqPayload = {
        type: this.$route.name,
        entite: this.entityId,
        projectId: this.voletIdProject
      }
      const list = !this.modeVue ? await this.getListAccess(reqPayload) : null

      this.usersTokenList = list ? list.data.data : list
    },
    resetColorBorders () {
      for (var i = 0; i < this.availableColors.length; i++) {
        this.availableColors[i].border = false
        this.availableColors[i].borderDark = false
      }
    },
    resetColors () {
      for (var i = 0; i < this.availableColors.length; i++) {
        this.availableColors[i].color = null
      }
    },
    toggleColorPickerVisibility (index, id) {
      this.colorIndex = index
      this.colorId = id

      // We reset any highlights and colors in case the user clicks on another cell color.
      // We only save the color once we click away on the cells or the colorpicker
      this.resetColorBorders()

      this.availableColors[index].border = true
      this.availableColors[index].borderDark = true

      this.showFontColorPicker = !this.showFontColorPicker
    },
    changeColor (color) {
      const { r, g, b, a } = color.rgba
      this.availableColors[this.colorIndex].color = `rgba(${r}, ${g}, ${b}, 1)`
    },
    away: async function () {
      this.showFontColorPicker = false
      this.resetColorBorders()

      var payload = {
        id: this.colorId,
        index: this.colorIndex,
        color: this.availableColors[this.colorIndex].color
      }

      await axios({ url: ENTRYPOINT + '/api/set-color', data: payload, method: 'POST' })

      // Update colors
      const resp = await axios({ url: ENTRYPOINT + '/api/get-colors', method: 'GET' })
      this.$store.commit('SET_COLORS', resp.data.colors.map(({ color }) => color))
    },
    handleClickTitre (titre) {
      if (titre === 'com' && this.comActive === false) {
        this.comActive = !this.comActive
        this.notifActive = !this.notifActive
        return
      }

      if (titre === 'notif' && this.notifActive === false) {
        this.notifActive = !this.notifActive
        this.comActive = !this.comActive
      }
    },

    handleClickShowVolet (section, $event) {
      if (this.showVolet && this.section === section) {
        this.showVolet = false
        return
      }
      this.section = section
      this.showVolet = true
    },
    async handleClickSendAccessRequest (payload) { // send invitation for access
      if (this.$route.name !== 'specification_technique' && this.$route.name !== 'cahier_environnemental') {
        this.message = 'Veuillez remplir les champs vide'
        this.notifClass = 'danger'
        if (payload.choices.length < 1) {
          this.message = 'Veuillez choisir un élément à partager'
        }
      }

      if (payload.email !== null && payload.nom !== null && payload.email !== '' && payload.nom !== '') {
        if (!this.checkEmail(payload.email)) {
          this.setMessage("Vérifiez le format de l' email")
          // this.showDismissibleAlert = true
          // setTimeout(() => { this.showDismissibleAlert = false }, 5000)
          return
        }
        this.btnDisable = true

        await this.setAccess(payload) // amelioration: renvoyer la liste des token directement

        const reqPayload = {
          type: this.$route.name,
          entite: this.entityId,
          projectId: this.voletIdProject
        }
        const list = !this.modeVue ? await this.getListAccess(reqPayload) : null

        this.usersTokenList = list ? list.data.data : list

        this.btnDisable = false
        this.message = 'Invitation envoyée'

        this.notifClass = 'info'
      }

      this.setMessage(this.message)
      // this.showDismissibleAlert = true
      // setTimeout(() => { this.showDismissibleAlert = false }, 5000)
    },
    checkEmail (email) {
      const re = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
      return re.test(email)
    },
    async createListModuleInModal (voletIdProject) { // create type module and identity list
      this.notLoadedList = false
      const currentProjectId = voletIdProject

      // create tableau list
      await this.getListOnglet(currentProjectId)

      const listOnglets = [...this.listOnglet().map(onglet => {
        return {
          id: onglet.id,
          name: onglet.nom
        }
      })]

      // create schema list
      await this.listAllSchema(currentProjectId)
      const listSchemas = [...this.listSchema().map(schema => {
        return {
          id: schema.id,
          name: schema.nom
        }
      })]

      // create fiche list
      /* if (this.$route.name === 'fiche_espace') {
        await this.getFicheTableaulists(currentProjectId)
      } */

      if (this.isProjectTemplate()) {
        this.listModules = {}
      } else {
        this.listModules = {
          'tableau_surface': listOnglets,
          'schema_fonctionnel': listSchemas,
          'fiche_espace': this.setFiches()
        }
      }

      this.notLoadedList = true

      // get list of invitation
      // const typeModule = this.$route.name
      // console.log('route name', typeModule, this.typeModule)
      // if (!this.typeModule) {
      this.setTypeModule(this.typeModule)

      // }
      if (this.typeModule && this.entityId) {
        this.getInvitationList(this.typeModule, this.entityId)
      }
    },
    getDenominationIndex (columnsData) {
      if (columnsData) {
        return columnsData.findIndex(col => col.key === 'H1')
      }
    },
    async getInvitationList (moduleType, entite) {
      // set type module from name of route
      const payload = {
        type: moduleType,
        entite: entite,
        projectId: this.voletIdProject
      }

      // if( moduleType !== 'schema_fonctionnel' ) {
      const list = await this.getListAccess(payload)
      this.usersTokenList = list ? list.data.data : []
      // }
    },
    async handleDeleteInvitation (id) {
      await this.deleteInvitation(id)
      await this.getInvitationList(this.typeModule, this.entityId)
    }

  }
}
</script>

<style lang="scss" scoped>
.volet-wrapper {
  position: fixed;
  z-index: 1002;
  right: 0;
  top: 125px;
  background: #fff;
  right: -467px;
  transition: right 0.5s ease;
  &.show {
    right: 0;
  }
  .toggle-volet-wrapper {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    height: calc(100vh - 56px);
    display: flex;
  }
  ul {
    padding-left: 0;
    list-style: none;
    li {
      padding: 5px 3px;
      div {
        height: 38px;
        width: 38px;
        border-radius: 50%;
        border: 1px solid #f9b11c;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        cursor: pointer;
        svg {
          color: #f9b11c;
        }
        .notification-number {
          display: block;
          background: red;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          color: #fff;
          position: absolute;
          top: -5px;
          right: 0;
          text-align: center;
          font-family: "Open Sans";
          font-weight: 600;
          font-size: 11px;
        }
      }
      &.active {
        div {
          background-color: #f9b11c;
          border: 1px solid #f9b11c;
          svg {
            color: #fff;
          }
        }
      }
    }
  }
  .volet-content-wrapper {
    width: 465px;
    height: 100%;
    box-shadow: inset 1px 0 0 0 #bed5e8;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
  }
}

.section-titre {
  display: flex;
  // border-bottom: 1px solid #2b3085;
  padding-top: 10px;
  justify-content: space-between;
  div {
    width: 48%;
    font-family: "Open Sans";
    color: #444444;
    text-transform: uppercase;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    padding-top: 0px;
    padding-bottom: 0px;
    border-radius: 3px;
    border: 1px solid #2b3085;
    &.active {
      background-color: #2b3085;
      color: #fff;
    }
  }
}
.section-contenu {
  padding: 15px;
}
.notification-box {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  padding-left: 30px;
  padding-right: 30px;
  .alert {
    padding-top: 5px;
    padding-bottom: 5px;
    font-family: "Open sans";
    font-weight: 600;
    font-size: 13px;
    left: 0;
    right: 0;
    button {
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }
}
.composant-acces {
  padding-top: 10px;
  position: relative;
}
.button-toggle-wrapper {
  position: fixed;
  right: 0px;
  top: 65px;
  z-index: 1000;
  .message-position {
    position: absolute;
    right: 100%;
    top: 10px;
  }
  ul {
    display: flex;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.style-btn {
  display: block;
  background: #2B3085;
  padding:5px 0;
  text-align: center;
  color:#fff;
  font-weight: bold;
  margin-bottom: 5px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}

  .my-padding {
    padding: 15px;
  }

  .available-colors {
    margin:15px 0;
    text-align: center;
  }
  .available-colors span{
    display:inline-block;
    cursor: pointer;
    width: 20px;
    margin-right: 6px;
    height:20px;
    background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAJ0lEQVQoU2M8c/X2fwYkYKylgsxlYKSDgv///6O44ey1O6huoL0CAJgaKeXe+C99AAAAAElFTkSuQmCC");
  }

  .hu-color-picker {
    position:absolute;
    width:219px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/voletLaterale/index.vue